import axios from 'axios';
import env from '../../env';

export const api = axios.create({
  baseURL: env.API_URL
  // baseURL: 'https://e5b7-2804-14c-7584-814d-18a4-cc80-78b-c71a.ngrok-free.app/'
}); 

// Criando uma API específica para acesso a recursos sob demanda
// Esta API utilizará o token de autenticação, mas será usada para
// consultas internas que seriam normalmente bloqueadas pela UI
export const internalApi = {
  /**
   * Obtém os detalhes de uma organização pelo ID, mesmo para usuários sem permissão direta
   * Usado principalmente para managers que precisam saber sua organização
   */
  getOrganizationById: async (organizationId: string): Promise<any> => {
    try {
      const token = localStorage.getItem('@App:token');
      if (!token) throw new Error('Token de autenticação não encontrado');
      
      // Rota alternativa que os managers têm permissão para acessar
      // Pode ser /api/prompt/organization/:id que tem permissões diferentes
      // ou /api/users/organization-info/:id que seria especialmente criada para isso
      const response = await api.get(`/api/prompt/organization/${organizationId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('Organização carregada via API interna:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erro ao acessar API interna para organização:', error);
      throw error;
    }
  }
};

